import { IUser } from '@common/interfaces/user'
import Base from './base'

export default class Users extends Base {
  list(query?: object) {
    return this.apiClient.get('users', query)
  }

  show(id: string) {
    return this.apiClient.get(`users/${id}`)
  }

  create(data: Partial<IUser & { clientId?: string }>) {
    return this.apiClient.post('users', data)
  }

  checkExistingClientLogin(data: { email: string; clientId: string }) {
    return this.apiClient.post('users/check-existing-client-login', data) as Promise<{
      data: { hasExistingLogin: boolean }
    }>
  }

  update(id: string, data: Partial<IUser & { clientId?: string }>) {
    return this.apiClient.put(`users/${id}`, data)
  }

  /** With `clientId`, someone who also belongs to other companies only loses this one. */
  delete(id: string, clientId?: string) {
    return this.apiClient.delete(`users/${id}`, clientId ? { clientId } : {})
  }

  invite(id: string) {
    return this.apiClient.post(`users/${id}/invite`)
  }

  inviteLink(id: string) {
    return this.apiClient.post(`users/${id}/invite-link`)
  }

  track_link(params?: object) {
    return this.apiClient.post('users/track_link', params)
  }
}
